import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import Sidebar from "../../components/sidebar";
import MyAlertsHome from "../../components/field_alerts/MyAlertsHome";
import { Container, SideContainer } from "../main_display/styles";
import { appStatus } from "../../store/modules/app_status/actions";

const ScrollSide = styled(SideContainer)`
  overflow-x: hidden !important;
  overflow-y: auto !important;
  -webkit-overflow-scrolling: touch;
`;

/** Rota /my-alerts — home de PROP/GUARDIAN. */
export default function MyAlertsPage() {
  const dispatch = useDispatch();
  const collapsed = useSelector((state) => state.sidebar);
  const [localCollapsed, setLocalCollapsed] = useState(false);

  useEffect(() => {
    dispatch(appStatus("Meus Alertas"));
  }, [dispatch]);

  return (
    <Container>
      <Sidebar
        collapsed={localCollapsed.toString()}
        setCollapsed={setLocalCollapsed}
      />
      <ScrollSide collapsed={(collapsed || localCollapsed).toString()}>
        <MyAlertsHome />
      </ScrollSide>
    </Container>
  );
}
